import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import httpClient from "../../../custom-hooks/httpClient";
import Loader from "react-loader-spinner";

const Referrals = () => {
  const user = useSelector((state) => state.user.user);
  const [loading, setLoading] = useState(false);
  const [referralsData, setReferralsData] = useState({
    referrals: [],
    count: 0,
  });

  const copyReferralCode = (referralCode) => {
    navigator.clipboard.writeText(referralCode);
    toast.info("Referral code copied to clipboard.");
  };

  useEffect(() => {
    const getReferrals = async () => {
      const userToken = localStorage.getItem("tk");
      try {
        setLoading(true);
        const response = await httpClient.get(`/referrals/${user.id}`, {
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        });
        setReferralsData({
          referrals: response.data.referrals,
          count: response.data.count,
        });
        toast.success(response.data.message);
      } catch (error) {
        console.error("Error fetching referrals:", error);
        toast.error("Error fetching referrals. Please, try again.");
      } finally {
        setLoading(false);
      }
    };

    if (user.id) {
      getReferrals();
    }
  }, [user.id]);
  return (
    <>
      <div className="col-12 col-md-9 ">
        <div className="card card-bleed shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row ">
              {loading && (
                <Loader type="Oval" color="#1c743a" height={20} width={20} />
              )}
              <div className="col-md-6 mb-4">
                <div className="form-group">
                  <label htmlFor="title" className="form-label text-secondary">
                    Referrals
                  </label>
                  <div>
                    <b>{referralsData.count}</b>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="form-group">
                  <label htmlFor="code" className="form-label text-secondary">
                    Referral Code
                  </label>{" "}
                  <div className="d-flex align-items-center">
                    <div>
                      <b>{user.referral_code}</b>
                    </div>
                    <button
                      className="btn btn-xs btn-primary ms-7"
                      onClick={() => copyReferralCode(user.referral_code)}
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card card-bleed  shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row"></div>
          </div>
        </div>

        <div className="card card-bleed shadow-light-lg mb-6">
          <div className="card-header">
            <div className="row ">
              <div className="col">
                <h4 className="mb-3 fw-bolder text-primary">My Referrals</h4>
                <table className="table">
                  <thead>
                    <tr>
                      <th className="text-secondary">S/N</th>
                      <th className="text-secondary">Referree</th>
                    </tr>
                  </thead>
                  <tbody>
                    {referralsData.referrals.length > 0 ? (
                      referralsData.referrals.map((referral, index) => (
                        <tr key={referral.id}>
                          <td>
                            <b>{index + 1}</b>
                          </td>
                          <td>
                            {" "}
                            <b>
                              {referral.first_name} {referral.last_name}
                            </b>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className="text-center">
                          Referral record unavailable.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Referrals;
